import React, { useState } from "react";
import PropTypes from "prop-types";
import isMobile from "is-mobile";
import "./PlayerProfilePreview.scss";
import playerIcon from "../../assets/imgs/Player_place_holder-09.svg";
import { PlayerBadge } from "../../"; // eslint-disable-line

const shrinkFont = name => {
  // shrink font size if the last name is more then eight charecters
  const lastName = name.slice(name.indexOf(" "));
  return lastName.length > 8 ? "0.5em" : "0.875em";
};

const PlayerProfilePreview = ({
  avatar,
  avatarBgColor,
  lastName,
  firstName,
  fullName,
  playerNumber,
  hasDetails,
  isTeam,
  handleMemberClick
}) => {
  const [hasImageError, setImageError] = useState(false);
  return (
    <div
      className="player-profile-preview"
      data-testid={`team-member-${fullName}`}
      onClick={handleMemberClick}
    >
      {avatar && !hasImageError ? (
        <img
          className="player-profile-preview__avatar"
          src={avatar || playerIcon}
          alt={isTeam ? "team-logo" : "player-avatar"}
          onError={() => setImageError(true)}
        />
      ) : (
        <div className="player-profile-preview__avatar">
          <PlayerBadge
            firstName={firstName}
            lastName={lastName}
            color={avatarBgColor}
          />
        </div>
      )}
      {hasDetails ? (
        <div className="player-profile-preview__details">
          <span className="player-profile-preview__details__number">
            {playerNumber || ""}
          </span>
          <span
            className="player-profile-preview__details__name"
            style={{
              fontSize: isTeam
                ? isMobile()
                  ? ""
                  : "0.9em"
                : shrinkFont(fullName)
            }}
          >
            {fullName}
          </span>
        </div>
      ) : null}
    </div>
  );
};

PlayerProfilePreview.propTypes = {
  avatar: PropTypes.oneOfType([PropTypes.string]),
  avatarBgColor: PropTypes.string,
  firstName: PropTypes.string,
  fullName: PropTypes.string,
  hasDetails: PropTypes.bool,
  lastName: PropTypes.string,
  playerNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

PlayerProfilePreview.defaultProps = {
  avatar: null,
  avatarBgColor: "",
  firstName: "",
  fullName: "",
  hasDetails: false,
  lastName: "",
  playerNumber: 0
};

export default PlayerProfilePreview;
